var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgV2EventHallStandard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 58,
    height: 58,
    viewBox: "0 0 58 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M6.646 52.3812C6.13245 52.3812 5.70199 52.2065 5.35459 51.8571C5.00719 51.5076 4.8335 51.0746 4.8335 50.5581C4.8335 50.0415 5.00719 49.6121 5.35459 49.2697C5.70199 48.9274 6.13245 48.7562 6.646 48.7562H9.84808V23.9249H6.58558C6.08807 23.9249 5.67168 23.7492 5.3364 23.3977C5.00113 23.0461 4.8335 22.6177 4.8335 22.1124C4.8335 21.7902 4.91405 21.4881 5.07516 21.2062C5.23627 20.9242 5.43766 20.6826 5.67933 20.4812L26.8856 5.49784C27.2227 5.24465 27.5675 5.07059 27.9199 4.97565C28.2723 4.88072 28.6324 4.83325 29.0002 4.83325C29.3679 4.83325 29.728 4.88072 30.0804 4.97565C30.4328 5.07059 30.7776 5.24465 31.1147 5.49784L52.321 20.4812C52.5627 20.6826 52.764 20.9343 52.9252 21.2364C53.0863 21.5385 53.1668 21.8506 53.1668 22.1728C53.1668 22.6703 52.9992 23.0867 52.6639 23.422C52.3286 23.7573 51.9123 23.9249 51.4147 23.9249H48.2127V48.7562H51.3543C51.8679 48.7562 52.2983 48.9309 52.6457 49.2803C52.9931 49.6297 53.1668 50.0627 53.1668 50.5792C53.1668 51.0958 52.9931 51.5253 52.6457 51.8676C52.2983 52.21 51.8679 52.3812 51.3543 52.3812H6.646ZM21.75 22.9581V43.4998H35.0417V40.8317H24.9191V34.5429H34.2314V31.8849H24.9191V25.6261H34.9186V22.9581H21.75Z",
    fill: "#6b7280"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgV2EventHallStandard);
export default __webpack_public_path__ + "static/media/v2-event-hall-standard.6ccc811d4755e34ba47a4e6278f4ec54.svg";
export { ForwardRef as ReactComponent };